import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  Box,
  Tabs,
  Tab,
} from "@mui/material";
// components

import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";

import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Editor } from "react-draft-wysiwyg";
import "../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {
  EditorState,
  convertToRaw,
  convertFromRaw,
  ContentState,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
//import "../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

// ----------------------------------------------------------------------

const isOlybet = process.env.REACT_APP_NAME === 'olybet';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1, paddingTop: 3 }}>{children}</Box>}
    </div>
  );
}

const defaultContent = {
  content_en: EditorState.createEmpty(),
  content_es: EditorState.createEmpty(),
  content_fr: EditorState.createEmpty(),
  content_lt: EditorState.createEmpty(),
  content_nl: EditorState.createEmpty(),
  content_rus: EditorState.createEmpty(),
  content_sl: EditorState.createEmpty(),
  content_esp: EditorState.createEmpty(),
  content_de: EditorState.createEmpty(),
};
const languages = ["en", "es", "fr", "lt", "nl", "rus", "sl", "esp", "de"];
export default function PageEditPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [matchStatsRows, setMatchStatsRows] = useState(null);
  const [teamStatsRows, setTeamStatsRows] = useState(null);
  const [pageId, setPageId] = useState(null);
  const [matches, setMatches] = useState([]);
  const [state, setState] = useState(defaultContent);
  const [value, setValue] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.has("page_id")) {
      let pageId = searchParams.get("page_id");
      setPageId(pageId);
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/admin/pages/${pageId}`)
        .then(function (response) {
          let state = defaultContent;
          for (let lang of languages) {
            const html = response.data.page[`content_${lang}`];
            const contentBlock = htmlToDraft(html);
            if (contentBlock) {
              const contentState = ContentState.createFromBlockArray(
                contentBlock.contentBlocks
              );
              state[`content_${lang}`] =
                EditorState.createWithContent(contentState);
            }
          }
          setState({ ...state });
        });
    }
  }, []);
  const handleChangeTabs = (event, newValue) => {
    setValue(newValue);
  };
  const handleChange = (event, lang) => {
    setState((prevState) => ({
      ...prevState,
      [`content_${lang}`]: event,
    }));
  };
  const saveHandler = () => {
    let page = {};
    for (let lang of languages) {
      page[`content_${lang}`] = draftToHtml(
        convertToRaw(state[`content_${lang}`].getCurrentContent())
      );
    }

    axios
      .put(`${process.env.REACT_APP_API_BASE_URL}/admin/pages/${pageId}`, page)
      .then((response) => {
        navigate(`/dashboard/pages`);
      });
  };
  return (
    <>
      <Helmet>
        <title> Page Edit </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            PageEdit
          </Typography>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:save-outline" />}
            onClick={() => saveHandler()}
            sx={{ mr: 2 }}
          >
            Save
          </Button>
        </Stack>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChangeTabs}
            aria-label="basic tabs example"
          >
            <Tab label="English" {...a11yProps(0)} />
            <Tab label="French" {...a11yProps(1)} />
            <Tab label="Slovak" {...a11yProps(2)} />
            <Tab label="Estonian" {...a11yProps(3)} />
            <Tab label="Latvian" {...a11yProps(4)} />
            <Tab label="Russian" {...a11yProps(5)} />
            {!isOlybet && <Tab label="Spanish" {...a11yProps(6)} />}
            {!isOlybet && <Tab label="German" {...a11yProps(7)} />}
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <Card sx={{ p: 2 }}>
            <Editor
              editorState={state.content_en}
              onEditorStateChange={(e) => handleChange(e, "en")}
            />
          </Card>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Card sx={{ p: 2 }}>
            <Editor
              editorState={state.content_fr}
              onEditorStateChange={(e) => handleChange(e, "fr")}
            />
          </Card>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <Card sx={{ p: 2 }}>
            <Editor
              editorState={state.content_sl}
              onEditorStateChange={(e) => handleChange(e, "sl")}
            />
          </Card>
        </TabPanel>
        <TabPanel value={value} index={3}>
          <Card sx={{ p: 2 }}>
            <Editor
              editorState={state.content_es}
              onEditorStateChange={(e) => handleChange(e, "es")}
            />
          </Card>
        </TabPanel>
        <TabPanel value={value} index={4}>
          <Card sx={{ p: 2 }}>
            <Editor
              editorState={state.content_lt}
              onEditorStateChange={(e) => handleChange(e, "lt")}
            />
          </Card>
        </TabPanel>
        <TabPanel value={value} index={5}>
          <Card sx={{ p: 2 }}>
            <Editor
              editorState={state.content_rus}
              onEditorStateChange={(e) => handleChange(e, "rus")}
            />
          </Card>
        </TabPanel>
        <TabPanel value={value} index={6}>
          <Card sx={{ p: 2 }}>
            <Editor
              editorState={state.content_esp}
              onEditorStateChange={(e) => handleChange(e, "esp")}
            />
          </Card>
        </TabPanel>
        <TabPanel value={value} index={7}>
          <Card sx={{ p: 2 }}>
            <Editor
              editorState={state.content_de}
              onEditorStateChange={(e) => handleChange(e, "de")}
            />
          </Card>
        </TabPanel>
      </Container>
    </>
  );
}
